export default __webpack_public_path__ + "static/media/Not Another Step.c275bc5d.png";